import { render } from "./terms-conditions-modal.vue?vue&type=template&id=61320424&scoped=true"
import script from "./terms-conditions-modal.vue?vue&type=script&lang=js"
export * from "./terms-conditions-modal.vue?vue&type=script&lang=js"

import "./terms-conditions-modal.vue?vue&type=style&index=0&id=61320424&lang=css"
import "./terms-conditions-modal.vue?vue&type=style&index=1&id=61320424&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61320424"]])

export default __exports__